import instance from './axiosConfig';

export const auth = {
  getToken: () => localStorage.getItem('token'),
  
  getUserType: () => localStorage.getItem('userType'),
  
  getUserName: () => localStorage.getItem('userName'),
  
  isAuthenticated: () => Boolean(localStorage.getItem('token')),
  
  isDistributor: () => localStorage.getItem('userType') === 'distributor',
  
  isBusiness: () => localStorage.getItem('userType') === 'business',
  
  isModerator: () => localStorage.getItem('userType') === 'moderator',

  isAdmin: () => localStorage.getItem('userType') === 'admin',

  hasPermission: (permission) => {
    const user = auth.getUser();
    return user?.permissions?.includes(permission);
  },
  
  getUser: () => {
    try {
      const userStr = localStorage.getItem('user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  },
  
  hasSeenPromoDialog: () => {
    return Boolean(localStorage.getItem('hasSeenPromo'));
  },
  
  markPromoDialogAsSeen: () => {
    localStorage.setItem('hasSeenPromo', 'true');
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    localStorage.removeItem('userName');
    localStorage.removeItem('user');
  },
  
  setCredentials: (token, userType, userName, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userType', userType);
    localStorage.setItem('userName', userName);
    localStorage.setItem('user', JSON.stringify(user));
  }
  
};

// Add interceptor to handle authentication headers
instance.interceptors.request.use(
  (config) => {
    const token = auth.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add interceptor to handle token expiration
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      auth.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
); 